import React from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate hook
import "../App.css";
import "./Discover.css";
import Header from './Header';
import cs2 from "../assets/cs2.png";
import dota2 from "../assets/dota2.jpeg";
import minecraft from "../assets/minecraft.jpeg";
import fortnite from "../assets/fortnite.png";
import gta5 from "../assets/gta5.png";
import valorant from "../assets/valorant.png"
import lol from "../assets/lol.jpeg"
import roblox from "../assets/roblox.png"
import apexlegends from "../assets/apex.png"
import l4d2 from "../assets/l4d2.jpeg"
import translations from "./translation.js";

const Discover = () => {
  const navigate = useNavigate(); // Initialize useNavigate hook
const currentLanguage = localStorage.getItem('selectedLanguage') || "en";
  const games = [
    { name: "Counter-Strike 2", type: "FPS", image: cs2 },
    { name: "Minecraft", type: "Sandbox", image: minecraft },
    { name: "Fortnite", type: "Battle-Royale", image: fortnite },
    { name: "Grand Theft Auto V", type: "Action-Adventure", image: gta5 },
    { name: "Dota 2", type: "MOBA", image: dota2 },
    { name: "Valorant", type: "FPS", image: valorant },
    { name: "Roblox", type: "Sandbox", image: roblox },
    { name: "Apex Legends", type: "Battle-Royale", image: apexlegends },
    { name: "Left 4 Dead 2", type: "Action-Adventure", image: l4d2 },
    { name: "League of Legends", type: "MOBA", image: lol },
    
  ];

  const handleGameClick = (gameType) => {
    // Navigate to route based on game type
    navigate(`/games/${gameType.toLowerCase()}`);
  };
  const showtype=(type)=>{
    switch (type) {
      case "FPS":
        return translations[currentLanguage].community1;
      case "Battle-Royale":
        return translations[currentLanguage].community2;
      case "MOBA":
        return translations[currentLanguage].community3;
      case "Sandbox":
        return translations[currentLanguage].community4;
      case "Action-Adventure":
        return translations[currentLanguage].community5;
    }
  }

  return (
    <div className="discover">
      <Header />
      <h1>Discover</h1>
      <div className="discov">
      <div className="games-container">
        {games.map((game, index) => (
          <div key={index} className="game-icon" onClick={() => handleGameClick(game.type)}>
            <img src={game.image} alt={game.name} />
            <div className="game-info">
              <p className="game-type">{showtype(game.type)}</p>
              <p className="game-name">{game.name}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
    </div>

  );
};

export default Discover;
